import isObject from "lodash.isobject"
import isString from "lodash.isstring"

// RTK Query signals connectivity failures via a string `status` instead of
// an HTTP code (no response was received).
const NETWORK_ERROR_STATUSES = ["FETCH_ERROR", "TIMEOUT_ERROR"]

// Browser fetch failures surface with these messages (Chrome/Firefox use
// "Failed to fetch", Safari uses "Load failed", Capacitor uses the offline
// string).
const NETWORK_ERROR_MESSAGES = [
  "Failed to fetch",
  "Load failed",
  "The Internet connection appears to be offline.",
]

export const isNetworkError = (e) => {
  if (!e) {
    return false
  }

  if (
    typeof e.status === "string" &&
    NETWORK_ERROR_STATUSES.includes(e.status)
  ) {
    return true
  }

  // `e.message` covers thrown Errors / reshaped ApiResponseError; `e.error`
  // covers a raw RTK FetchBaseQueryError that hasn't been reshaped yet.
  return [e.message, e.error].some(
    (text) =>
      typeof text === "string" &&
      NETWORK_ERROR_MESSAGES.some((needle) => text.includes(needle)),
  )
}

function concatObjectValues(object) {
  return Object.keys(object)
    .map((key) => {
      if (key === "_error_code") {
        return ""
      }

      if (!isNaN(Number(key)) && Number(key) > 0) {
        return
      }

      let item = object[key]
      if (isObject(item)) {
        return formatErrorResponse(item)
      }

      if (Array.isArray(item)) {
        if (key !== "detail") {
          item = item.map((i) => {
            if (isObject(i)) {
              return formatErrorResponse(i)
            }

            return i
          })
          return `${key} - ${[...new Set(item.flat())]}`
        } else {
          return [...new Set(item.flat())].join(", ")
        }
      } else {
        if (key !== "detail" && key !== "0") {
          return `${key} - ${item}`
        } else {
          return item
        }
      }
    })
    .filter((s) => s !== "")
    .join("\n")
    .replace("_error", "error")
}

function concatErrorArray(errors) {
  return errors
    .map((entry) => {
      if (isObject(entry)) {
        return concatObjectValues(entry)
      } else {
        return entry
      }
    })
    .join("\n")
    .replace("_error", "error")
}

export function formatErrorResponse(response) {
  if (Array.isArray(response)) {
    return concatErrorArray(response)
  } else if (isObject(response)) {
    return concatObjectValues(response)
  } else if (isString(response)) {
    return response
  } else {
    return JSON.stringify(response)
  }
}

export const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
